// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__LFWJe","buttonFake":"styles_buttonFake__kB1Xl","invisibleText":"styles_invisibleText__mzNsq"};